import { API_REFERENCE } from '../utilities/constant_api';
import { htmlGet, jsonGet } from '../components/ajax';
import { truncateText } from '../utilities/utility';
const loadAlertsUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutAlerts.showAlerts}`;
const alertTopDiv = '.alertdropdownlistDetails';
const alertList = '.alert-list';
const alertListLi = '.alerts-content ul.alertsUl li.alertsList';
const dropdownlistDetails = '.dropdownlistDetails';
const alertdropdownlistDetails = '.alertdropdownlistDetails';
const mobCloseAlerts = '.mobCloseAlerts';
const closeAlerts = '.closeAlerts';
const clsAlertRedirect = '.alert-insurance-redirect';
let closeAlertClicked = false;
let checkoutAlertsListAjaxFlag = true;
let checkoutResolveAlertsListAjaxFlag = true;

const alertsFunction = {
  openAlerts() {
    if (!checkoutAlertsListAjaxFlag) return false;
    checkoutAlertsListAjaxFlag = false;
    htmlGet(loadAlertsUrl)
      .then(response => {
        checkoutAlertsListAjaxFlag = true;
        if (response) {
          const sanitizedHtml = ACC.sanitizer.sanitizeHtmlDeeply(response);
          $(alertTopDiv).html(sanitizedHtml);
          var alertLists = $('.alertsUl .alertsList a');
          for (var list = 0; list < alertLists.length; list++) {
            if (alertLists[list].innerText.length > 65) {
              var truncatedString =
                alertLists[list].innerText.substr(0, 65) + '...';
              alertLists[list].innerText = truncatedString;
            }
          }
          if ($(dropdownlistDetails).hasClass('show')) {
            $(dropdownlistDetails).removeClass('show');
            $('.nav-loggedInProfile-btn').attr('aria-expanded', false);
            $(alertdropdownlistDetails).addClass('show');
            alertsFunction.trapFocus($(alertdropdownlistDetails));
            setTimeout(function() {
              $('.closeAlerts').focus();
            }, 200);
          } else if ($(alertdropdownlistDetails).hasClass('show')) {
            $(alertdropdownlistDetails).removeClass('show');
          } else {
            $(alertdropdownlistDetails).addClass('show');
            alertsFunction.trapFocus($(alertdropdownlistDetails));
            setTimeout(function() {
              $('.closeAlerts').focus();
            }, 200);
          }
        }
      })
      .catch(error => {
        checkoutAlertsListAjaxFlag = true;
      });
  },
  toggleAlertsDropdown() {
    if ($(dropdownlistDetails).hasClass('show')) {
      $(dropdownlistDetails).removeClass('show');
      $('.nav-loggedInProfile-btn').attr('aria-expanded', false);
    }
    closeAlertClicked = true;
    $(alertdropdownlistDetails).removeClass('show');
    $('.nav-cart-icon').focus();
  },
  closeAlertsDropdown(e) {
    if (e.keyCode === 27) {
      if ($(alertdropdownlistDetails).hasClass('show')) {
        $(closeAlerts).trigger('click');
      }
    }
  },
  resolveInsurance() {
    const alertId = $(this).attr('data-alertId');
    const url =
      `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutAlerts.notify}` +
      alertId;
    const redirectURL = $(this).attr('data-url');
    if (!checkoutResolveAlertsListAjaxFlag) return false;
    checkoutResolveAlertsListAjaxFlag = false;
    jsonGet(url)
      .then(response => {
        checkoutResolveAlertsListAjaxFlag = true;
        window.location.href = redirectURL;
      })
      .catch(error => {
        checkoutResolveAlertsListAjaxFlag = true;
      });
  },
  toggleAlertsDropdownEnter(e) {
    if (e.keyCode === 13) {
      $(this).trigger('click');
    }
  },
  trapFocus($element) {
    $(document).on('focus', 'div, input', function(e) {
      if (
        !$element[0].contains(e.target) &&
        e.target !== $element[0] &&
        !closeAlertClicked
      ) {
        e.preventDefault();
        e.stopPropagation();
        $($element[0]).addClass('show');
        $($element[0]).focus();
      }
    });
  },
  toggleAlertsDropdownFocus(e) {
    if (e.shiftKey && e.keyCode == 9) {
      setTimeout(function() {
        $('.alert-list').focus();
        if (window.innerWidth > 767) {
          $(alertdropdownlistDetails).removeClass('show');
        }
      }, 100);
    }
    if ($('.alertsUl a').length === 0) {
      if (e.keyCode == 9 && !e.shiftKey) {
        setTimeout(function() {
          $('.nav-cart-icon').focus();
          if (window.innerWidth > 767) {
            $(alertdropdownlistDetails).removeClass('show');
          }
        }, 100);
      }
    }
  },
  toggleAlertsDropdownFocusFromLink(e) {
    if (e.keyCode == 9 && !e.shiftKey) {
      setTimeout(function() {
        $('.nav-cart-icon').focus();
        if (window.innerWidth > 767) {
          $(alertdropdownlistDetails).removeClass('show');
        }
      }, 100);
    }
  },
  getAlertNotificationList() {
    setTimeout(function() {
      if ($(alertdropdownlistDetails).hasClass('show')) {
        $(document).on('swiperight', alertsFunction.swipefunction);
      }
    }, 500);
  },
  swipefunction(e) {
    if ($(alertdropdownlistDetails).hasClass('show')) {
      let alertlastelement = '.alertsUl .alertsList a:last';

      if (
        $('.listZeroElement').is(':focus') ||
        $('.allNotifications').is(':focus') ||
        $(alertlastelement).is(':focus')
      ) {
        $('.alertdropdownlistDetails').removeClass('show');
        setTimeout(function() {
          $('.nav-cart-icon').focus();
        }, 200);
      }
    }
  },
  swipebackfunction(e) {
    if ($('.alertTitleBack').is(':focus')) {
      $('.alertdropdownlistDetails').removeClass('show');
      setTimeout(function() {
        $('.nav-loggedInProfile-notif-btn').focus();
      }, 200);
    }
  },
  init() {
    $(document).on('click', alertList, this.openAlerts);
    $(document).on('click', mobCloseAlerts, this.toggleAlertsDropdown);
    $(document).on('click', closeAlerts, this.toggleAlertsDropdown);
    $(document).on('keyup', closeAlerts, this.toggleAlertsDropdownEnter);
    $(document).on('keydown', closeAlerts, this.toggleAlertsDropdownFocus);
    $(document).on(
      'keydown',
      '.alerts-content a:last',
      this.toggleAlertsDropdownFocusFromLink
    );
    $(document).on('click', clsAlertRedirect, this.resolveInsurance);
    $(document).keyup(this.closeAlertsDropdown);

    $(document).on('swipeleft', this.swipebackfunction);
    $(document).on('tap', alertList, this.getAlertNotificationList);
  }
};
alertsFunction.init();
export default alertsFunction;
